import React from 'react';
import classNames from 'classnames';
import { Spin, SpinProps } from 'antd';

import style from './spinner.module.scss';

interface Props extends SpinProps {
	className?: string;

	// If don't want to use the size param, pass a custom size (e.g. '24px')
	customSize?: string;

	['data-test-id']?: string;
}

const SpinnerWrapper: React.FC<Props> = (props: Props) => {
	const { className, customSize, ...otherProps } = props;
	return (
		<div className={classNames('spinner-wrapper', className)}>
			<Spin
				{...otherProps}
				style={customSize ? ({ '--custom-spinner-size': customSize } as React.CSSProperties) : {}}
				className={classNames({
					[style.spinnerUseCustomSize]: !!customSize
				})}
			/>
		</div>
	);
};

SpinnerWrapper.defaultProps = {
	size: 'large'
};

export default SpinnerWrapper;
